var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(!_vm.canEditInline)?_c('div',{class:[
      'm-0',
      _vm.xBigCaption ? 'text-body-small-posts' : 'text-body-extra-small',
      'font-sans',
      {
        'text-dark-text-200 focus:text-dark-text-100': _vm.darkThemeType === 'browser' || !_vm.isDark,
        'dark:text-light-text-200 dark:focus:text-light-text-100': _vm.darkThemeType === 'browser',
        'text-light-text-200 focus:text-light-text-100': _vm.darkThemeType === 'custom' && _vm.isDark,
      },
    ],staticStyle:{"word-break":"break-word"},on:{"click":function($event){return _vm.$emit('click', $event)},"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.$emit('click', $event)},"dblclick":function($event){return _vm.$emit('edit-start')}}},[_vm._v("\n    "+_vm._s(_vm.captionBeingDisplayed ? _vm.captionBeingDisplayed : _vm.xPlaceholder ? _vm.__('Add a caption') : '')+"\n  ")]):_c('multiline-input',{ref:"input",class:[
      'm-0',
      _vm.xBigCaption ? 'text-body-small-posts' : 'text-body-extra-small',
      'font-sans',
      {
        'text-dark-text-200 focus:text-dark-text-200 placeholder-dark-text-300':
          _vm.darkThemeType === 'browser' || !_vm.isDark,
        'dark:text-light-text-200 dark:focus:text-light-text-200 dark:placeholder-light-text-300':
          _vm.darkThemeType === 'browser',
        'text-light-text-200 focus:text-light-text-200 placeholder-light-text-300':
          _vm.darkThemeType === 'custom' && _vm.isDark,
      },
    ],attrs:{"value":_vm.captionBeingDisplayed,"title":_vm.__('Post attachment caption'),"aria-label":_vm.__('Post attachment caption'),"placeholder":_vm.__('Add a caption'),"max-length":160,"dir":"auto","readonly":!_vm.canEditInline,"dir":_vm.dir},on:{"input":_vm.onChange,"focus":_vm.onEditStart,"blur":_vm.onEditEnd}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }